import { ZestyWYSIWYGField } from '@apis/models/zesty.api.model';
import ZestyApi from '@apis/zesty.apis';
import { IsTheme, Theme } from '@app/core/featureToggle';
import REText from '@components/wrappedBDS/REText';
import { Checkbox, Panel } from '@ftdr/blueprint-components-react';
import React, { useEffect, useState } from 'react';

export interface EnableBuyerCardNotificationProps {
  isChecked?: boolean;
  onChange?: (value: boolean) => void;
  isCheckboxDisabled?: boolean;
}

export const CACHED_BUYER_PAY_MESSAGE = 'cachedBuyerPayMessage';

const EnableBuyerPayNotification: React.FC<EnableBuyerCardNotificationProps> = (props) => {
  const [loading, setLoading] = useState<boolean>(false);
  const [message, setMessage] = useState<ZestyWYSIWYGField>(null);
  const cachedMessage = sessionStorage.getItem(CACHED_BUYER_PAY_MESSAGE);

  useEffect(() => {
    if (cachedMessage) {
      setMessage(cachedMessage);
    } else {
      setLoading(true);
      ZestyApi.GetBuyerPayMessage()
        .then((buyerPayMessage) => {
          sessionStorage.setItem(CACHED_BUYER_PAY_MESSAGE, buyerPayMessage?.message);
          setMessage(buyerPayMessage?.message);
        })
        .catch((e) => {
          console.error('failed to load zesty buyer pay', e);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, []);

  return !loading && message ? (
    <div className="m-2 w-full">
      <Panel
        backgroundColor={IsTheme(Theme.Ahs2024) ? 'accent-500' : 'interactive-50'}
        rounded={IsTheme(Theme.Ahs2024) ? 'xl' : 'md'}
        borderColor="gray-300"
        className="flex"
      >
        <Checkbox
          id="buyer-pay-checkbox"
          className="pr-1"
          checked={props.isChecked}
          disabled={props.isCheckboxDisabled}
          onChange={() => props.onChange?.(!props.isChecked)}
        />
        <REText
          variant="body-short"
          className="inline"
          dangerouslySetInnerHTML={{ __html: message }}
        />
      </Panel>
    </div>
  ) : (
    <></>
  );
};

EnableBuyerPayNotification.defaultProps = {
  isCheckboxDisabled: false,
  isChecked: false,
};

export default EnableBuyerPayNotification;
